import React from 'react';
import { EmailServerValidatedControl } from 'src/components/common/EmailInput/EmailServerValidatedControl';
import { useEmailControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/EmailControlWrapper/hooks/useEmailControlWrapper';

export function EmailControlWrapper(): JSX.Element {
  const { disabled, disabledInfo } = useEmailControlWrapper();

  return (
    <EmailServerValidatedControl
      name="email"
      id="email"
      disabled={disabled}
      disabledInfo={disabledInfo}
    />
  );
}
